export const IconTypes = {
  ATTENTION: 'attention',
  ARROW_BOT: 'arrow-bot',
  ARROW_DOWN: 'arrow-down',
  ARROW_LEFT: 'arrow-left',
  ARROW_NEXT: 'arrow-next',
  ARROW_NEXT_LONG: 'arrow-next-long',
  ARROW_PREV: 'arrow-prev',
  ARROW_RIGHT: 'arrow-right',
  ARROW_TOP: 'arrow-top',
  ARROW_UP: 'arrow-up',
  BASKET: 'basket',
  CAR: 'car',
  CATALOG: 'catalog',
  CROSS: 'cross',
  COMPARISON: 'comparison',
  CARD: 'card',
  COPY_LINK: 'copy-link',
  DELETE: 'delete',
  ELLIPSIS: 'ellipsis',
  GIFT: 'gift',
  FILTER: 'filter',
  EYE: 'eye',
  EYE_CLOSED: 'eye-closed',
  GEO: 'geo',
  HEIGHT: 'height',
  HEART: 'heart',
  HISTORY: 'history',
  HOUSE: 'house',
  LK: 'lk',
  MENU: 'menu',
  MOBILE_RUBRICATOR: 'mobile-rubricator',
  TALK_ME: 'talk-me',
  PHONE: 'phone',
  PROMO: 'promo',
  PROFILE: 'profile',
  RUBLE: 'ruble',
  FAT_SHARE: 'fat-share',
  QR: 'qr',
  SBP: 'sbp',
  SHARE: 'share',
  SEARCH: 'search',
  SHOP: 'shop',
  SIMILE: 'simile',
  SORTING: 'sorting',
  SORTING2: 'sorting2',
  TRASHBIN: 'trashbin',
  LOCATION_WARNING: 'location-warning',
  LOCATION: 'location',
  MAP_LOCATION: 'map-location',
  NEWCARD: 'newcard',
  RETURN: 'return',
  SUCCESS: 'success',
  STAR: 'star',
  SQUARE: 'square',
  VOLUME: 'volume',
  WIDTH: 'width',
  MINUS: 'minus',
  PLUS: 'plus',
  PLAIT: 'plait',
  BONUS_PROMO: 'bonus-promo',
  FAT_HEART: 'fat-heart',
  FAT_HEART_FILLED: 'fat-heart-filled',
  FAT_SIMILE: 'fat-simile',
  FILE_PDF: 'file-pdf',
  BONUS: 'bonus',
  BONUS_DISABLED: 'bonus-disabled',
  LOCATION_FILLED: 'location-filled',
  UPDATE_RESTORE: 'update-restore',
} as const;

export type IconTypes = (typeof IconTypes)[keyof typeof IconTypes];

export const IconSizes = {
  xs: 'xs',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
} as const;

export type IconSizes = (typeof IconSizes)[keyof typeof IconSizes];
